(function () {
    'use strict';

    angular
        .module('app.categoryIcons')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                state: 'categoryicons',
                  config: {
                      abstract: true,
                      url: '/categoryicons',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.userType() == "0") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'categoryicons.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/categoryIcons/list.html?v=' + opsIncludeVersion,
                    controller: 'CategoryIconsListController',
                    controllerAs: 'vm',
                    title: 'Category Icons'
                }
            }
        ];
    }
})();
